import { TeamsListData } from "./types";

export const getPropertyToSortBy = (
  currentTab: TeamsListData["currentTab"],
  metric: TeamsListData["metric"]
) => {
  if (currentTab === "lateStart" && metric === "time") {
    return "rawNumMinsLateStart";
  } else if (currentTab === "lateStart" && metric === "percent") {
    return "percentMeetingsWithLateStart";
  } else if (currentTab === "overTime" && metric === "time") {
    return "numMinsMeetingOverage";
  } else {
    return "percentMeetingsWithOverage";
  }
};
